<template>
  <div>
    <!-- <div class="text-center cust-padding">
      <span class="py-2">Today</span>
    </div> -->
    <div class="flex items-start" :class="[messageDirection]">
      <div class=" ">
        <div class="flex justify-end" v-if="username">
          <p class="text-black inline-block p-1 rounded-t-sm">
            Agent: {{ username }}
          </p>
        </div>
        <div class="flex justify-end" v-if="checkbotmessage">
          <p class="text-black inline-block p-1 rounded-t-sm">Bot</p>
        </div>

        <div
          :id="'message-' + message._id"
          class="break-words relative shadow-md py-3 px-4 mb-2 rounded-lg max-w-sm message-item"
          :class="[
            messageChat,
            {
              'bg-warning': textMessage === '3',
              'bg-primary text-white': textMessage === '4',
            },
          ]"
        >
          <div class="flex">
            <div class="block">
              <div v-if="checkimagelink">
                <img :src="checkimagelink.url" class="w-full bg-fas h-20" />
                <span class="">{{ checkimagelink.caption }}</span>
              </div>

              <div v-if="checkvideo">
                <video controls class="w-full bg-fas h-20">
                  <source :src="checkvideo.url" />
                </video>
                <span class=""> {{ checkvideo.caption }}</span>
              </div>
              <div v-if="checkaudio">
                <video controls class="w-full bg-fas h-20">
                  <source :src="checkaudio" />
                </video>
              </div>
              <div>
                <span class="" v-if="textMessage" v-html="textMessage"></span>
              </div>
              <div v-if="checkbotmessage">
                <span class="" v-html="checkbotmessage"></span>
              </div>
           
              <div v-if="checkContact">
              <div class="">
                <p class="font-semibold w-full pb-3 t-bordert" v-html="checkContact.name"></p>
              
                <p class="pt-3" v-html="checkContact.number"></p>
              </div>

              </div>
              <feather-icon
                v-if="isLocation"
                icon="MapPinIcon"
                svgClasses="h-16 w-16 stroke-current text-grey"
                class="block"
              />
            </div>
          </div>
          <div
            class="fsize10 mt-2 w-full"
            :class="{ 'flex justify-end': isInbound }"
          >
            {{ messageTime }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imagess: false,
      forwordmesage: false,
      inboundMessageChatCSS: "inboundmessage-text-bg",
      outboundMessageChatCSS: "outboundmessage-text-bg",
      inboundMessageDirectionCSS: "flex-row-reverse mr-4 ml-4",
      outboundMessageDirectionCSS: "flex-row ml-4 mr-4",
    };
  },
  computed: {
    ...mapGetters("whatsappChat", {
      activeChat: "activeChat",
    }),
    messageSource() {
      return this.message.payload.source;
    },
    activeSource() {
      return this.activeChat.phone;
    },
    isInbound() {
      return this.messageSource === this.activeSource;
    },
    messageDirection() {
      return !this.isInbound
        ? this.inboundMessageDirectionCSS
        : this.outboundMessageDirectionCSS;
    },
    messageChat() {
      return this.isInbound
        ? this.inboundMessageChatCSS
        : this.outboundMessageChatCSS;
    },
    //
    textMessage() {
      return (this.message &&
        this.message.payload &&
        this.message.payload.type &&
        ((this.message.payload.type === "message" &&
          this.message.payload.id !== "BOT_MESSAGE") ||
          this.message.payload.type === "text" ||
          this.message.payload.type === "event") &&
        this.message.payload.payload &&
        this.message.payload.payload.text) ||
        this.message.payload.payload.title
        ? this.message.payload.payload.text ||
            this.message.payload.payload.title
        : "";
    },
    checkimagelink() {
      return this.message &&
        this.message.payload &&
        this.message.payload.type &&
        this.message.payload.type === "image" &&
        this.message.payload.payload &&
        this.message.payload.payload
        ? this.message.payload.payload
        : "";
    },
    checkvideo() {
      return this.message &&
        this.message.payload &&
        this.message.payload.type &&
        this.message.payload.type === "video" &&
        this.message.payload.payload &&
        this.message.payload.payload.url
        ? this.message.payload.payload.url
        : "";
    },
    checkaudio() {
      return this.message &&
        this.message.payload &&
        this.message.payload.type &&
        this.message.payload.type === "audio" &&
        this.message.payload.payload &&
        this.message.payload.payload.url
        ? this.message.payload.payload.url
        : "";
    },
    checkContact() {
      if (this.message.payload.type === "contact"){
console.log(this.message.payload.payload.contacts[0].name.first_name,"yesssssssssssssssss")
let contactobj={
  number:this.message.payload.payload.contacts[0].phones[0].phone,
  name:this.message.payload.payload.contacts[0].name.first_name
}
console.log(contactobj,"contactobjcontactobj")
return contactobj 
      }
     
    },
    checkbotmessage() {
      console.log(this.message.payload.id === "BOT_MESSAGE");
      if (this.message.payload.id === "BOT_MESSAGE") {
        let result = "";
        result = this.message.payload.payload.text;
        
        console.log(result, "resultresult");

        let replace = result.replace(/\(Bot\)\s*/, "");
        console.log(replace,"replacereplacereplace")
       
       
        try{
          let parseres = JSON.parse(replace);
          return parseres.body
      
        }catch(err){
          return replace

        }
         
      }

      // console.log(replace)
      // return replace
    },
    username() {
      if (this.message.payload.payload.username) {
        return this.message.payload.payload.username || " ";
      }
      // return "A"

      // return this.message.payload.username || " "
    },
    isLocation() {
      return this.message.payload.type === "location";
    },
    isImage() {
      return this.message.payload.type === "image";
    },
    imageLink() {
      return this.isImage ? this.message.payload.payload.text : "";
    },
    messageTime() {
      // return new Date(Number(this.message.timestamp)).toLocaleString();
      return moment(new Date(Number(this.message.timestamp))).format("hh:mm a");
    },
  },
  methods: {
    handleImageClick() {
      window.open(this.imageLink, "_blank");
    },
  },
};
</script>
<style>
.cust-padding {
  padding: 5px 12px 6px;
}
.t-bordert{
  border-bottom: 1px solid #8080804f;
}
</style>
